export default {
  optionWrapper: 'flex w-full gap-[8px]',
  optionItem: 'cursor-pointer rounded-lg border border-[#CEDCEC] w-full flex justify-center gap-2 p-4 relative',
  activeOptionItem: 'border-[#EC6D25] bg-[#F0F3F6]',
  disabledOptionItem: 'pointer-events-none brightness-110',
  checkIcon: 'absolute top-2 left-2',
  optionItemTitle: 'text-[#70747E]',
  activeOptionItemTitle: 'text-[#EC6D25]',
};
